export default class User {
    /**
     * @return {RegExp}
     */
    static get passwordRegExp() {
        // eslint-disable-next-line
        return new RegExp("^(?=.*[0-9])(?=.*[-?!@#$%^&*])[a-zA-Z0-9\-?!@#$%^&*]{8,25}$");
    }
}
